import React, {useEffect, useState} from 'react';
import {Modal, Table} from 'antd';
import {TestExecutionDto, TestPlanExecutionDto, TestPlanControllerApi} from '../../../api';
import TestPlanExecutionDetailsModal from "./TestPlanExecutionDetailsModal";
import {formatDateTime, renderStatusAmpel} from "../../../utils/Utils";
import {useKeycloakHeader} from "../../../config/Config";

/*
Dieses Modal zeigt alle Ausführungen eines Testplans an
 */
const TestPlanExecutionModal: React.FC<{ visible: boolean; testPlanId: number; onClose: () => void }> = ({
                                                                                                             visible,
                                                                                                             testPlanId,
                                                                                                             onClose
                                                                                                         }) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedTestExecution, setSelectedTestExecution] = useState<TestExecutionDto>();
    const [testPlanExecutions, setTestPlanExecutions] = useState<TestPlanExecutionDto[]>();

    const headers = useKeycloakHeader();
    const testPlanControllerApi = new TestPlanControllerApi();

    useEffect(() => {
        testPlanControllerApi.getAllTestPlanExecutionsForTestPlan(testPlanId, headers)
            .then((axiosResponse) => {
                const executions: Array<TestPlanExecutionDto> = axiosResponse.data.map((testPlanExecution: TestPlanExecutionDto) => ({
                    ...testPlanExecution,
                    executionTime: formatDateTime(testPlanExecution.executionTime)
                }));
                setTestPlanExecutions(executions);
            })
            .catch((error) => {
                console.error('Fehler beim Abrufen der Daten:', error);
            });
    }, [visible]);




    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Ausführung',
            dataIndex: 'executionTime',
            key: 'executionTime',
        },
        {
            title: 'Status',
            dataIndex: 'runStatus',
            key: 'runStatus',
            width: '5%',
            render: (text, record) => (
                <span>{renderStatusAmpel(record.runStatus)}</span>
            ),
        },
    ];

    const handleRowClick = (record) => {
        setSelectedTestExecution(record);
        setModalVisible(true);
    };

    return (
        <>
            <Modal
                title="Testplan-Ausführung"
                open={visible}
                onCancel={onClose}
                footer={null}
                width={1000}
            >
                <Table
                    dataSource={testPlanExecutions?.map(testPlanExecutionDto => ({
                        ...testPlanExecutionDto,
                        key: testPlanExecutionDto.id
                    }))}
                    columns={columns}
                    onRow={(record) => ({
                        onClick: () => {
                            handleRowClick(record);
                        },
                    })}
                    locale={{emptyText: 'Keine Daten vorhanden'}}
                />
            </Modal>
            {selectedTestExecution?.id &&
                <TestPlanExecutionDetailsModal visible={modalVisible} testPlanExecutionId={selectedTestExecution.id} onClose={() => setModalVisible(false)}/>}
        </>
    );
};

export default TestPlanExecutionModal;
